import React from 'react'
import ReactDOM from 'react-dom'

import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider'
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils'
import { MuiThemeProvider } from 'material-ui/styles'

import registerServiceWorker from './registerServiceWorker'
// import 'helpers/console'

import { theme } from 'helpers/theme'
import App from './App'

import 'assets/css/styles.css?v=1.2.0'

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <App />
    </MuiPickersUtilsProvider>{' '}
  </MuiThemeProvider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js